import React, {useState} from 'react';
import {
  View,
  Text,
  ImageBackground,
  TouchableOpacity,
  Image,
} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import {useNavigation} from '@react-navigation/native';
import MyLearnCenter from './myLearnCenter';
import WrongQuestion from './wrong/wrongQuestion';

export default function MyLearn() {
  const navigation = useNavigation();
  const [currentTab, setCurrentTab] = useState(1);
  return (
    <>
      <View style={styles.myLearnBox}>
        {currentTab === 1 ? (
          <View style={styles.myLearnBoxLeft}>
            <TouchableOpacity
              onPress={() => {
                // @ts-ignore
                navigation.navigate('SynchroWorkbook');
              }}>
              <ImageBackground
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_tongbuu.png?t=1',
                }}
                resizeMode="cover"
                imageStyle={{padding: 0, margin: 0}}
                style={styles.myLearnBtnStyle}>
                <Text style={styles.myLearnBtnStyleTitle}>AI 同步测</Text>
                <Text style={styles.myLearnBtnStyleDesc}>
                  章节、知识点同步练习
                </Text>
              </ImageBackground>
            </TouchableOpacity>
          </View>
        ) : currentTab === 2 ? (
          <View style={styles.flex1}>
            <MyLearnCenter />
          </View>
        ) : (
          <View style={styles.flex1}>
            <WrongQuestion />
          </View>
        )}

        <View style={{flexDirection: 'row', alignItems: 'center'}}>
          <View style={styles.myLearnBoxRight}>
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => {
                setCurrentTab(1);
              }}
              style={styles.workBookDetailsBoxBtnItem}>
              <Image
                style={styles.workBookDetailsBoxBtnItemImg}
                source={{
                  uri:
                    currentTab === 1
                      ? 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_beikao_a.png'
                      : 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_beikao.png',
                }}
              />
              <View
                style={[
                  styles.workBookDetailsBoxBtnItemBox,
                  currentTab === 1 && styles.workBookDetailsBoxBtnItemBoxA,
                ]}>
                <Text style={styles.workBookDetailsBoxBtnItemText}>
                  AI同步测
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => {
                // @ts-ignore
                setCurrentTab(2);
              }}
              style={styles.workBookDetailsBoxBtnItem}>
              <Image
                style={styles.workBookDetailsBoxBtnItemImg}
                source={{
                  uri:
                    currentTab === 2
                      ? 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_center_a.png'
                      : 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_center.png',
                }}
              />
              <View
                style={[
                  styles.workBookDetailsBoxBtnItemBox,
                  currentTab === 2 && styles.workBookDetailsBoxBtnItemBoxA,
                ]}>
                <Text style={styles.workBookDetailsBoxBtnItemText}>
                  我的学案
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.6}
              onPress={() => {
                // @ts-ignore
                setCurrentTab(3);
              }}
              style={styles.workBookDetailsBoxBtnItem}>
              <Image
                style={styles.workBookDetailsBoxBtnItemImg}
                source={{
                  uri:
                    currentTab === 3
                      ? 'https://media.oss.leziedu.com/webapp/classroom/wrong/cuoti_icon_yes.png'
                      : 'https://media.oss.leziedu.com/webapp/classroom/wrong/cuoti_icon_no.png',
                }}
              />
              <View
                style={[
                  styles.workBookDetailsBoxBtnItemBox,
                  currentTab === 3 && styles.workBookDetailsBoxBtnItemBoxA,
                ]}>
                <Text style={styles.workBookDetailsBoxBtnItemText}>错题本</Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
  },
  myLearnBox: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#fff',
  },
  myLearnBoxLeft: {
    flex: 1,
    padding: '7rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  myLearnBtnStyle: {
    width: '24.2rem',
    height: '38rem',
    marginLeft: '9rem',
    paddingTop: '5.5rem',
    padding: '2.65rem',
    // flex: 1,
    resizeMode: 'cover',
    // justifyContent: 'center',
  },
  myLearnBtnStyleTitle: {
    fontSize: '1.9rem',
    color: '#3D3D3D',
  },
  myLearnBtnStyleDesc: {
    marginTop: '0.25rem',
    fontSize: '1.2rem',
    color: '#B6B6B6',
  },
  myLearnBoxRight: {
    marginRight: '2.55rem',
    marginLeft: '0.8rem',
    width: '7.25rem',
    height: '32.25rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  workBookDetailsBoxBtnItemBox: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '6.1rem',
    height: '2.1rem',
    // borderRadius: '1.05rem',
  },
  workBookDetailsBoxBtnItemBoxA: {
    borderRadius: '1.05rem',
    backgroundColor: '#543DFF',
  },
  workBookDetailsBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },
});
